import VacancyWrapper from './VacancyWrapper.page';

export default VacancyWrapper;
